import { pageTrackerPageView, pageTrackerLogger } from "@/common/pageTracker";
import { getUserType } from "@/services/user/user.service";

export default {
  methods: {
    saveMatomoTrackerPageView(params) {
      pageTrackerPageView(params);
    },
    handlePageTrackerEvent(category, action, name) {
      const userType = getUserType();
      if (userType) {
        category = userType + "_" + category;
      }
      let _paq = (window._paq = window._paq || []);
      _paq.push(["trackEvent", category, action, name]);
      pageTrackerLogger(
        "Page Tracker Event " +
          category +
          " " +
          action +
          " " +
          name +
          " logged."
      );
    },
  },
};
